import * as angular from 'angular';
import { PWAService } from './pwa.service';

export const PWAModule = angular.module('PWAModule', [])
	.service(PWAService.NG1_INJECTION_NAME, PWAService)
	.name;
